<!-- eslint-disable vue/multi-word-component-names -->
<template>
  <div>
    <div class="maskbox" v-show="isHovered"></div>
    <div class="header flex app-ban">
        <router-link v-if="!searchState.showSearchInput" to="/" style="padding: 0 20px;">{{ homeLabel }}</router-link>
      <!-- 正常导航栏 -->
      <div v-if="!searchState.showSearchInput" class="nav flex">
          <div
            class="flex box"
            v-for="(section, sIdx) in navSections"
            :key="sIdx"
            @mouseenter="isHovered = true"
            @mouseleave="isHovered = false"
          >
              <div class="txttxt">{{ section.title[lang] }}<div class="lineline"></div></div>
              <div class="whitebox">
                  <div class="flex whitebox-div">
                      <p class="whitebox-p" v-for="(item, idx) in section.items" :key="idx"><router-link :to="item.to">{{ item.label[lang] }}</router-link></p>
                  </div>
              </div>
          </div>
      </div>
      <router-link :style="{ position: isMobile == 'PC' && 'absolute', left: isMobile == 'PC' && '50%', transform: isMobile == 'PC' && 'translateX(-50%)',zIndex: isMobile == 'PC' && '-1'}" to="/"><img v-if="!searchState.showSearchInput" class="logo" src="../assets/newlogo.png" ></router-link>
      <!-- <router-link v-if="!searchState.showSearchInput" to="/" style="padding: 0 20px;">{{ homeLabel }}</router-link> -->
      <!-- 正常导航栏 -->
      <!-- <div v-if="!searchState.showSearchInput" class="nav flex">
          <div
            class="flex box"
            v-for="(section, sIdx) in navSections"
            :key="sIdx"
            @mouseenter="handleMouseEnter"
            @mouseleave="handleMouseLeave"
          >
              <div class="txttxt">{{ section.title[lang] }}<div class="lineline"></div></div>
              <div class="whitebox">
                  <div class="flex">
                      <p v-for="(item, idx) in section.items" :key="idx"><router-link :to="item.to">{{ item.label[lang] }}</router-link></p>
                  </div>
              </div>
          </div>
      </div> -->
      
        <!-- 搜索输入框 -->
        <div v-if="searchState.showSearchInput" class="search-input-container">
          <div class="search-input-wrapper">
            <div class="search-icon">
              <img src="@/assets/search.png" alt="search" />
            </div>
            <input
              ref="searchInputRef"
              v-model="searchState.searchQuery"
              type="text"
              :placeholder="searchLabels.placeholder[currentLanguage || 'zh']"
              class="search-input"
              @keyup.enter="performSearch"
              @blur="handleInputBlur"
            />
            <button @click="cancelSearch" class="close-btn">
              <span>×</span>
            </button>
          </div>
        </div>
      <img v-else src="../assets/search.png" class="search" @click="handleSearch">
      <div class="languagecontinar" @click="toggleLan">
        <div class="flex">
            <p>{{ languageLabel }}</p><img src="../assets/zhuan.png" class="language-arrow" :style="{transform: showLanguage ? 'rotate(270deg)' : 'rotate(90deg)'}">
        </div>
        <ul v-show="showLanguage" class="languagebox">
            <li @click.stop="setLanguageUI('zh')">中文</li><li @click.stop="setLanguageUI('en')">English</li>
        </ul>
      </div>
      <div class="flex box ipad" @mouseenter="showCode = true" @mouseleave="showCode = false" @touchstart="showCode = true" @touchend="handleTouchEnd">
        <p>{{ ticketLabel }}</p>
        <div v-show="showCode" class="codebox"><img class="img-code" :src="codecode"></div>
      </div>
      <div v-if="isLoading" class="loading-indicator">加载中...</div>
    </div>
  </div>
  
</template>

<script setup>
  /* eslint-disable vue/multi-word-component-names */
  import { ref, onMounted, watch, computed, nextTick } from 'vue';
  import { useRouter, useRoute } from 'vue-router';
  import { getfriendList } from "../utils/gerData";
  import { currentLanguage, setLanguage as setGlobalLanguage } from "../utils/lang";
  import { headerLabels, searchLabels,imageurl } from "../utils/i18nLabels";
  import { searchState, searchMethods } from "../utils/searchStore";
  
  const isMobile = localStorage.getItem('userAgent')
  const router = useRouter();
  const route = useRoute();
  const isHovered = ref(false);
  const showCode = ref(false);
  const showLanguage = ref(false);
  const codecode = ref('')
  const languageLabel = ref('Language')
  const isLoading = ref(false)

  // 搜索相关的响应式数据 - 使用全局状态
  const searchInputRef = ref(null);

  const navSections = headerLabels.sections

  const lang = computed(() => currentLanguage.value || 'zh')
  const homeLabel = computed(() => headerLabels.home[lang.value])
  const ticketLabel = computed(() => headerLabels.buyTickets[lang.value])

  function handleMouseEnter(){
    isHovered.value = true;
  }
  function handleMouseLeave(){
    isHovered.value = false;
  }
  function toggleLan(){
      showLanguage.value = !showLanguage.value;
  }
  
  // 处理触摸结束事件
  function handleTouchEnd() {
    // 使用setTimeout延迟隐藏，避免点击二维码时立即消失
    setTimeout(() => {
      showCode.value = false;
    }, 300);
  }
  async function setLanguageUI(lang){
      setGlobalLanguage(lang);
      languageLabel.value = lang === 'zh' ? '中文' : 'English';
      showLanguage.value = false;
      
      // 如果当前正在搜索状态，更新搜索关键词
      if (searchState.showSearchInput) {
        const newSearchQuery = searchLabels.placeholder[lang];
        searchMethods.setSearchQuery(newSearchQuery);
        
        // 如果在搜索结果页面，执行新的搜索
        if (route.name === 'SearchResults') {
          await performSearch();
        }
      }
      
      isLoading.value = true;
      try {
        await getList();
      } finally {
        isLoading.value = false;
      }
  }
  function initLanguageLabel(){
      const stored = currentLanguage.value || 'zh';
      languageLabel.value = stored === 'zh' ? '中文' : 'English';
  }
  // 获取列表数据
    async function getList() {
        let queryParams1 = {
            category_id: 2
        }
        const res = await getfriendList(queryParams1)
        const data = res.data
        data.list.map(item => {
            item.logo = item.logo ? imageurl + item.logo : undefined
        })
        codecode.value = data.list[0].logo;
    }
    
    // 搜索相关方法
    async function handleSearch() {
        // 显示搜索输入框，隐藏导航栏
        searchMethods.setShowSearchInput(true);
        searchMethods.setSearching(true);
        
        // 等待DOM更新后聚焦输入框
        await nextTick();
        if (searchInputRef.value) {
            searchInputRef.value.focus();
        }
        
        // 跳转到搜索结果页面（不带参数）
        router.push({ name: 'SearchResults' });
        
        // 执行默认搜索
        await performSearch();
    }
    
    // 执行搜索
    async function performSearch() {
        const currentLang = currentLanguage.value || 'zh';
        const defaultQuery = searchLabels.placeholder[currentLang];
        const query = searchState.searchQuery || defaultQuery;
        if (query.trim()) {
            await searchMethods.performSearch(query.trim());
        }
    }
    
    // 取消搜索
    function cancelSearch() {
        searchMethods.clearSearch();
        // 如果当前在搜索页面，则导航回首页
        if (route.name === 'SearchResults') {
            router.push({ name: 'newpcIndex' });
        }
    }
    
    // 处理输入框失焦
    function handleInputBlur() {
        // 延迟处理，避免点击按钮时立即失焦
        setTimeout(() => {
            if (!document.activeElement || 
                (!document.activeElement.classList.contains('search-btn') && 
                 !document.activeElement.classList.contains('cancel-btn'))) {
                // 如果不是点击搜索或取消按钮导致的失焦，则不自动关闭
            }
        }, 100);
    }
    
    
    onMounted(() => {
      initLanguageLabel();
      getList();
      // 先尝试恢复搜索状态
      restoreSearchState();
      checkSearchState();
    });
    
    // 恢复搜索状态
    function restoreSearchState() {
      const savedQuery = searchMethods.restoreSearchQuery();
      if (savedQuery && route.name === 'SearchResults') {
        searchMethods.setSearchQuery(savedQuery);
      }
    }
    
    watch(currentLanguage, (newLang) => {
      languageLabel.value = newLang === 'zh' ? '中文' : 'English'
      
      // 如果当前正在搜索状态，更新搜索关键词
      if (searchState.showSearchInput && searchState.searchQuery) {
        const newSearchQuery = searchLabels.placeholder[newLang];
        searchMethods.setSearchQuery(newSearchQuery);
        
        // 如果在搜索结果页面，执行新的搜索
        if (route.name === 'SearchResults') {
          performSearch();
        }
      }
    });
    
    // 监听路由变化
    watch(route, () => {
      // 先尝试恢复搜索状态
      restoreSearchState();
      checkSearchState();
    });
    
    // 检查是否应该显示搜索状态
    function checkSearchState() {
      if (route.name === 'SearchResults') {
        searchMethods.setShowSearchInput(true);
        searchMethods.setSearching(true);
        // 如果没有搜索关键词，尝试从本地存储恢复，否则设置默认值
        if (!searchState.searchQuery) {
          const savedQuery = searchMethods.restoreSearchQuery();
          if (!savedQuery) {
            const currentLang = currentLanguage.value || 'zh';
            const defaultQuery = searchLabels.placeholder[currentLang];
            searchMethods.setSearchQuery(defaultQuery);
          }
        }
      } else {
        // 只隐藏搜索输入框，但保留搜索关键词
        searchMethods.setShowSearchInput(false);
        searchMethods.setSearching(false);
      }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .header{
        position: fixed;
        width: 100%;
        height: 100px;
        margin: 0 auto;
        padding: 0 30px;
        background: white;
        box-sizing: border-box;
        z-index: 2;
        .logo{
            width: 80px;
            margin-right: 30px;
        }
        .nav{
            flex: 1;
            justify-content: flex-start;
        }
        
        .box{
            position: relative;
            padding: 0 20px;
            cursor: pointer;
            height: 40px;
            line-height: 40px;
            &:hover{
                height: 100px;
                line-height: 100px;
            }
            .txttxt{
                position: relative;
                font-size: 16px;
                color: black;
                line-height: 40px;
                min-width: 64px;
                text-align: center;
                &:hover {
                    font-weight: bold;
                }
            }
            img{
                width: 6px;
                margin-left: 10px;
                transform: rotate(90deg);
            }
            .codebox{
                position: absolute;
                bottom: -240px;
                right: 0;
                box-shadow: 5px 5px 5px 2px rgba(0, 0, 0, 0.3);
                .img-code{
                    width: 200px;
                    transform: rotate(0);
                    margin: 0;
                    display: block;
                }
            }
        }
        .languagecontinar {
            position: relative;
            padding: 0 20px;
            cursor: pointer;
            
            .language-arrow {
                width: 6px;
                margin-left: 10px;
            }
            
            .languagebox{
                position: absolute;
                width: 100px;
                background: white;
                top: 40px;
                right: 0;
                list-style-type: none;
                border-radius: 4px;
                padding: 5px 0;
                box-shadow: 5px 5px 5px 2px rgba(0, 0, 0, 0.3);
                li{
                    line-height: 40px;
                }
            }
        }
        .search{
            width: 20px;
            margin-right: 10px;
            cursor: pointer;
        }
        
        /* 搜索输入框样式 */
        .search-input-container {
            flex: 1;
            display: flex;
            align-items: center;
            justify-content: center;
        }
        
        .search-input-wrapper {
            display: flex;
            align-items: center;
            width: 100%;
            /* height: 18px; */
            background-color: #f5f5f5;
            border-radius: 15px;
            padding: 12px 20px;
            box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
            border: 1px solid #0b90f2;
        }
        
        .search-icon {
            margin-right: 12px;
            opacity: 0.6;
            display: flex;
            align-items: center;
        }
        
        .search-icon img {
            width: 18px;
            height: 18px;
        }
        
        .search-input {
            flex: 1;
            border: none;
            background: transparent;
            font-size: 18px;
            font-family: '宋体';
            color: #3e3e3e;
            outline: none;
            padding: 0;
            height: 24px;
            line-height: 24px;
        }
        
        .search-input::placeholder {
            color: #999;
            font-size: 18px;
        }
        
        .close-btn {
            background: none;
            border: none;
            cursor: pointer;
            padding: 0;
            margin-left: 12px;
            display: flex;
            align-items: center;
            justify-content: center;
            width: 24px;
            height: 24px;
            border-radius: 50%;
            transition: background-color 0.2s;
        }
        
        .close-btn:hover {
            background-color: rgba(0, 0, 0, 0.1);
        }
        
        .close-btn span {
            font-size: 20px;
            color: #666;
            line-height: 1;
            font-weight: normal;
        }
        
        .lineline{
            position: absolute;
            bottom: -30px;
            left: 0;
            width: 0;
            height: 2px;
            background: black;
            transition: width .4s;
        }
        .whitebox{
            border-top: 2px solid #f0f0f0;
            position: fixed;
            width: 100%;
            height: 0;
            background: white;
            top: 100px;
            left: 0;
            padding: 0 100px;
            box-sizing: border-box;
            visibility: hidden;
            transition: height .3s ease-in .3s, visibility .3s ease-in .3s;
            .whitebox-div{
                height: 95px;
                opacity: 0;
                transition: opacity .3s;
                .whitebox-p{
                    /* margin: 0 100px; */
                    a:hover{
                        color: #bfbfbf;
                    }
                }
            }
        }
        .box:hover .whitebox{
            height: 95px;
            visibility: visible;
            transition: height .3s ease-in;
        }
        .box:hover .whitebox>div{
            opacity: 1;
            transition: opacity .3s .3s;
        }
        .box:hover .lineline{
            width: 70px;
            transition: width .4s;
        }
        .loading-indicator{
            margin-left: 10px;
            color: #666;
            font-size: 12px;
        }
    }
    
    
    /* 平板和iPad适配 - 保持与PC端一致的样式 */
    @media (min-width: 769px) and (max-width: 1400px) {
        .header {
            padding: 0 20px !important;

            .box {
                position: relative !important;
                padding: 0 0.625rem;
                .codebox {
                    position: absolute;
                    top: 90px;
                    right: 0;
                    display: block;
                }
            }
            
            .languagecontinar {
                padding: 0 20px !important;
                
                .language-arrow {
                    width: 6px !important;
                    margin-left: 10px !important;
                }
                
                .languagebox {
                    position: absolute !important;
                    width: 100px !important;
                    top: 100% !important;
                    right: 0 !important;
                    margin-top: 5px !important;
                    z-index: 1000 !important;
                    
                    li {
                        line-height: 40px !important;
                    }
                }
            }
        }
        
    }

    
    /* 移动端适配 */
    @media (max-width: 768px) {
        .header {
            padding: 0 15px;
        }
        
        .search-input-container {
            padding: 0 10px;
        }
        
        .search-input-wrapper {
            padding: 10px 16px;
            border-radius: 25px;
        }
        
        .search-icon img {
            width: 16px;
            height: 16px;
        }
        
        .search-input {
            font-size: 14px;
        }
        
        .search-input::placeholder {
            font-size: 14px;
        }
        
        .close-btn {
            width: 20px;
            height: 20px;
        }
        
        .close-btn span {
            font-size: 18px;
        }
    }
</style>